import React, { useState, useEffect } from 'react';
import {
  Grid, Button, InputBase, Alert, IconButton, Tooltip, Box, Modal, Typography
} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LoginUsuario, getLink, silentRefresh } from '../utils/ApiLogin';
import Logo from '../assets/img/LogoItg.png';
import Traductor from '../components/Traductor';
import { useNavigate } from 'react-router-dom';
import Base from '../components/BaseLogos/Base'; // Asegúrate de que el componente Base esté en esta ruta
import {
  Translate as TranslateIcon,
  AccountCircle as UserIcon,
  LockOutlined as LockIcon,
  LockOpen as UnlockIcon,
  CheckBoxOutlineBlank as Blank,
  CheckBox as Checked,
} from '@mui/icons-material';

import ContactMailIcon from '@mui/icons-material/ContactMail';
import '../assets/css/Login.css';

// Definición de tema oscuro
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#90caf9' },
    background: {
      default: '#121212',
      paper: '#1d1d1d'
    },
  },
});

const Login = ({ servidor, translate, idioma, SWVersion, handleClick, openMenuIdioma, handleCloseIdioma, handleLanguageChange }) => {
  const navigate = useNavigate();
  const [input_username, setInput_Username] = useState('');
  const [input_password, setInput_Password] = useState('');
  const [showPassword, setShowPassword]   = useState(false);
  const [rememberMe, setRememberMe]       = useState(false);
  const [error, setError]                 = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading]             = useState(false);

  // NUEVOS estados para el modal de “Olvidé mi contraseña”
  const [modalOpen, setModalOpen] = useState(false);
  const [forgotValue, setForgotValue] = useState('');

    // Abre el modal
  const handleOpenModal = () => {
    setForgotValue('');
    setError('');
    setSuccessMessage('');
    setModalOpen(true);
  };
  // Cierra el modal
  const handleCloseModal = () => {
    setModalOpen(false);
  };


  // Envía el formulario de “olvidé contraseña”
  const handleSendEmail = async () => {
    setError('');
    let nombre = '';
    let correo = '';

    // Detectamos si es correo (contiene "@") o nombre
    if (forgotValue.includes('@')) {
      correo = forgotValue.trim();
    } else {
      nombre = forgotValue.trim();
    }

    try {
      // Asumimos que getLink acepta dos args: getLink(nombre, correo)
      const data = await getLink(nombre, correo, servidor);

      console.log('data',data)
      if (data) {
        setSuccessMessage('Enlace enviado para restablecer la contraseña.');
        setModalOpen(false);
      } else {
        setError('Ocurrió un error');
      }
    } catch (e) {
      setError(e.message);
    }
  };


  const handleLogin = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const success = await LoginUsuario({ input_username, input_password, servidor, rememberMe, navigate });
      success ? (navigate('/home')) : setError(translate('login_error_message'));
    } catch {
      setError(translate('login_error_message'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    silentRefresh(servidor).then(ok => ok && (navigate('/home')));
  }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <Box className="login-form-container">
        <Box className="lang-selector">
          <Tooltip title={translate(idioma)} arrow>
            <IconButton onClick={handleClick}><TranslateIcon style={{fontSize:'1vw'}}/></IconButton>
          </Tooltip>
          <Traductor
            idioma={idioma}
            openMenuIdioma={openMenuIdioma}
            handleCloseIdioma={handleCloseIdioma}
            handleLanguageChange={handleLanguageChange}
            translate={translate}
          />
        </Box>


        <Box component="form" onSubmit={handleLogin} className="login-form">
          <img src={Logo} className="logo" alt="Logo ITG" />
          <h2 className="form-title">{translate('login')}</h2>
          <Grid container spacing={2}>
            {/* USUARIO */}
            <Grid item xs={12}>
              <label className="label">
                <span className="title">{translate('username')}</span>
                <div className="input-wrapper">
                  <UserIcon className="icon" />
                  <InputBase
                    fullWidth
                    className="input-field"
                    placeholder={translate('username')}
                    value={input_username}
                    onChange={e => setInput_Username(e.target.value)}
                    required
                  />
                </div>
              </label>
            </Grid>

            {/* CONTRASEÑA */}
            <Grid item xs={12}>
              <label className="label">
                <span className="title">{translate('password')}</span>
                <div className="input-wrapper">
                  {showPassword
                    ? <UnlockIcon className="icon" onClick={() => setShowPassword(false)}/>
                    : <LockIcon className="icon" onClick={() => setShowPassword(true)}/>
                  }
                  <InputBase
                    fullWidth
                    className="input-field"
                    type={showPassword ? 'text' : 'password'}
                    placeholder={translate('password')}
                    value={input_password}
                    onChange={e => setInput_Password(e.target.value)}
                    required
                  />
                </div>
              </label>
            </Grid>

            {/* RECUÉRDAME */}
            <Grid item xs={12}>
              <Button
                sx={{ color: '#e84e0e', fontSize: '1vw' }}
                onClick={() => setRememberMe(r => !r)}
                startIcon={rememberMe ? <Checked style={{fontSize:'1.2vw'}}/> : <Blank style={{fontSize:'1.2vw'}}/>}
              >
                {translate('recuerdame')}
              </Button>
            </Grid>

            {/* BOTÓN LOGIN */}
            <Grid item xs={12}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  fontSize: '1vw',
                  padding: '1.5vh 0',
                  backgroundColor: '#e84e0e',
                  color:'#fff',
                  '&:hover': { backgroundColor: '#d84300' }
                }}
                disabled={loading}
              >
                {loading ? translate('loading') : translate('login_button')}
              </Button>
            </Grid>

            {error && (
              <Grid item xs={12}>
                <Alert severity="error" sx={{ fontSize: '1vw' }}>{error}</Alert>
              </Grid>
            )}
          </Grid>
          <div className="olvidaste-pass" onClick={handleOpenModal}>¿{translate('forgot_password')}?</div>
          <div className="version">{SWVersion}</div>
        </Box>

        {successMessage && (
          <Grid item xs={12} style={{position:'absolute',  marginTop:'-20.25vh', marginLeft:'4vw', zIndex:'9999'}}>
            <Alert severity="success" sx={{ fontSize: '1vw' }}>
              {successMessage}
              </Alert>
          </Grid>
         )}

           {/* Modal de “Olvidaste tu contraseña” con MUI Modal */}
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="modal-forgot-password"
          closeAfterTransition
          BackdropProps={{ timeout: 500 }}
        >
          <Box sx={styleModal}>
            <Box className="login-form">
            <h2 id="modal-forgot-password" gutterBottom className="form-title"> {translate('forgot_password')}</h2>
              <Grid container spacing={2}>
                {/* USUARIO */}
                <Grid item xs={12}>
                  <label className="label">
                    <span className="title">{translate('username_or_email')}</span>
                    <div className="input-wrapper">
                      <ContactMailIcon className="icon" />
                      <InputBase
                        fullWidth
                        className="input-field"
                        placeholder={translate('username_or_email')}
                        value={forgotValue}
                        onChange={e => setForgotValue(e.target.value)}
                        required
                      />
                    </div>
                  </label>
                </Grid>

                {/* BOTÓN  */}
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      fontSize: '1vw',
                      padding: '1.5vh 0',
                      backgroundColor: '#e84e0e',
                      color:'#fff',
                      '&:hover': { backgroundColor: '#d84300' }
                    }}
                    disabled={!forgotValue.trim()}
                    onClick={handleSendEmail}
                  >
                    {translate('send_mail')}
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                      fontSize: '1vw',
                      padding: '1.5vh 0',
                      backgroundColor: '#e84e0e',
                      color:'#fff',
                      '&:hover': { backgroundColor: '#d84300' }
                    }}
                    onClick={handleCloseModal}
                  >
                    {translate('salir')}
                  </Button>
                </Grid>

                {error && (
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ fontSize: '1vw' }}>{error}</Alert>
                  </Grid>
                )}
              </Grid>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Box>
          </Box>
        </Modal>


        <Base />
      </Box>
    </ThemeProvider>

  );
};

export default Login;


const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40vw',
  bgcolor: 'rgb(9, 11, 14)',
  borderRadius: 1,
  boxShadow: 24,
  p: 4,
};

// import React, { useState, useEffect } from 'react';
// import {
//   Grid,
//   Button,
//   TextField,
//   Alert,
//   InputBase,
//   Divider,
//   IconButton,Tooltip
// } from '@mui/material';
// import { LoginUsuario } from '../utils/ApiLogin';
// import '../assets/css/Login.css';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import Base from '../components/BaseLogos/Base';
// import Logo from '../assets/img/LogoItg.png';
// import Traductor from '../components/Traductor';
// import { dotSpinner } from 'ldrs';
// import TranslateIcon from '@mui/icons-material/Translate';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import LockOpenIcon from '@mui/icons-material/LockOpen';

// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';


// import CryptoJS from 'crypto-js';  // Importar crypto-js para encriptar y desencriptar

// dotSpinner.register();

// const darkTheme = createTheme({
//   palette: {
//     mode: 'dark',
//     background: {
//       default: 'black',
//     },
//   },
//   components: {
//     MuiDrawer: {
//       styleOverrides: {
//         paper: {
//           backgroundColor: 'rgb(255,255,255.01)',
//         },
//       },
//     },
//   },
// });

// const secretKey = 'mySecretKey123';  // Llave secreta para la encriptación


// const Login = ({ fileContent, translate,idioma, SWVersion, handleClick, openMenuIdioma, handleCloseIdioma, handleLanguageChange }) => {

//   // define en el mismo archivo, o impórtalo desde Traductor si exportas el array
//   const languageLabels = {
//     es: translate('es'),
//     en: translate('en'),
//     no: translate('no_idioma'),
//     jp: translate('jp'),
//     zh: translate('zh'),
//     fr: translate('fr'),
//     ar: translate('ar'),
//     ru: translate('ru'),
//     pt: translate('pt'),
//   }
//   // calculas la etiqueta a mostrar en traductor
//   const idiomaLabel = languageLabels[idioma] || idioma

//   const [input_email, setInput_Email] = useState("");
//   const [input_username, setInput_Username] = useState("");
//   const [input_password, setInput_Password] = useState("");
//   const [showEmailField, setShowEmailField] = useState(true);
//   const [error, setError] = useState('');
//   const [fallaConexion, setFallaConexion] = useState(false);
//   const [cargando, setCargando] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [rememberMe, setRememberMe] = useState(localStorage.getItem('rememberMe')); // Estado para "Recuérdame"
// console.log('rememberMe',rememberMe)
//   useEffect(() => {
//     // Verificar si hay credenciales guardadas en localStorage
//     const savedUser = localStorage.getItem('user');
//     const savedPassword = localStorage.getItem('password');
//     const savedRememberMe = localStorage.getItem('rememberMe');

//     if (savedUser && savedPassword && savedRememberMe === 'true') {
//       const decryptedUser = decryptData(savedUser);
//       const decryptedPassword = decryptData(savedPassword);
//       setInput_Username(decryptedUser);
//       setInput_Password(decryptedPassword);
//       handleLoginAuto(decryptedUser, decryptedPassword); // Autologin
//       console.log('savedUser',savedUser)
//       console.log('savedPassword',savedPassword)

//     }
//   }, []);


//   const handleButtonClick = (fieldType) => {
//     if (fieldType === 'Email') {
//       setShowEmailField(true);
//     } else if (fieldType === 'Nombre Usuario') {
//       setShowEmailField(false);
//     }
//   };

//   const handleLogin = async (event) => {
//     event.preventDefault();  // Previene el comportamiento predeterminado del formulario
//     setCargando(true);
//     setFallaConexion(false);

//     try {
//       const login = await LoginUsuario({ input_username, input_password, input_email, fileContent });

//       if (login) {
//         console.log('Inicio de sesión exitoso');
//         saveCredentials(input_username, input_password);  // Guardar en localStorage

//         setFallaConexion(false);
//         setCargando(false);
//       } else {
//         console.error('Error al iniciar sesión');
//         setCargando(false);
//         setFallaConexion(true);
//         setError(translate('login_error_message'));
//       }
//     } catch (error) {
//       console.error('Error al iniciar sesión:', error);
//       setError(translate('login_error_message'));
//     }
//   };

//   const handleLoginAuto = async (username, password) => {
//     setCargando(true);
//     setFallaConexion(false);

//     const encryptedUser = localStorage.getItem('user');
//     const encryptedPassword = localStorage.getItem('password');
  
//     if (encryptedUser && encryptedPassword) {
//       try {
//         const username = decryptData(encryptedUser);
//         const password = decryptData(encryptedPassword);
  
//         // Hacer el login usando las credenciales desencriptadas
//         const login = await LoginUsuario({ input_username: username, input_password: password, fileContent });
  
//         if (login) {
//           console.log('Inicio de sesión automático exitoso');
//         } else {
//           console.error('Error al iniciar sesión automáticamente');
//         }
//       } catch (error) {
//         console.error('Error desencriptando las credenciales:', error);
//       }
//     } else {
//       console.error('No se encontraron credenciales en localStorage');
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//    // Función para encriptar los datos antes de guardarlos en localStorage
//    const encryptData = (data) => {
//     return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
//   };

//   // Función para desencriptar los datos de localStorage
//   const decryptData = (encryptedData) => {
//     const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
//     return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   };

//   // Guardar usuario y contraseña encriptados en localStorage
//   const saveCredentials = (username, password) => {
//     const encryptedUser = encryptData(username);
//     const encryptedPassword = encryptData(password);
//     localStorage.setItem('user', encryptedUser);
//     localStorage.setItem('password', encryptedPassword);
//   };

//   const HandleRecuerdame = () => {
//     setRememberMe(!rememberMe);
//     localStorage.setItem('rememberMe',!rememberMe)
//   };


//   return (
//     <ThemeProvider theme={darkTheme}>
//       <CssBaseline />
//       <Grid container justifyContent="center" alignItems="center" className="root" style={{ cursor: 'default !important', userSelect: 'none', overflow: 'hidden' }}>
//         <Grid container justifyContent="flex-end">
//           <Tooltip title={idiomaLabel} placement="bottom" arrow>
//             <IconButton onClick={handleClick} style={{ marginRight: '1vw' }}>
//               <TranslateIcon style={{ fontSize: '2vh', color: '#e84e0e' }} />
//             </IconButton>
//           </Tooltip>
//           <Traductor handleLanguageChange={handleLanguageChange} openMenuIdioma={openMenuIdioma} handleCloseIdioma={handleCloseIdioma} idioma={idioma} translate={translate} />
//         </Grid>
//         <Grid container justifyContent="center" item xs={3} className="paper" style={{ zIndex: 1 }}>
//           <Grid container justifyContent="center">
//             <Grid container justifyContent="center">
//               <h2 variant="h4" className="title"> {translate('login')}</h2>
//             </Grid>
//             <form onSubmit={handleLogin}>
//               <Grid container className="buttonContainer">
//                 {/* Botones para cambiar entre Email y Nombre de Usuario */}
//               </Grid>
//               <Grid container justifyContent="center" className="form">
//                 <Grid container justifyContent='center'>
//                   {showEmailField ? (
//                     <Grid
//                       component="div"
//                       style={{ alignItems: 'center', width: '20vw', height: '6vh', border: 'solid 0.1vh #505151', borderRadius: '2vh', marginTop: '4vh' }}>
//                       <Grid container justifyContent='center'>
//                         <AccountCircleIcon style={{ fontSize: '1.5vw', marginTop: '1.2vh', marginLeft: '0.5vw', zIndex: 0 }} />
//                         <Divider sx={{ height: '4vh', marginLeft: '0.5vw', marginTop: '0.8vh' }} orientation="vertical" />
//                         <InputBase
//                           autoFocus
//                           style={{ marginLeft: '0.5vw', marginTop: '0.5vh', fontSize: '1.25vw', width: '15.5vw' }}
//                           placeholder={translate('username')}
//                           value={input_username}
//                           onChange={(e) => setInput_Username(e.target.value)}
//                         />
//                       </Grid>
//                     </Grid>
//                   ) : (
//                     <TextField
//                       style={{ width: "20vw", marginLeft: "2.5vw" }}
//                       label={translate('email')}
//                       type="email"
//                       onChange={(e) => setInput_Email(e.target.value)}
//                     />
//                   )}
//                   <Grid
//                       component="div"
//                       style={{ alignItems: 'center', width: '20vw', height: '6vh', border: 'solid 0.1vh #505151', borderRadius: '2vh', marginTop: '4vh' }}>
//                       <Grid container justifyContent='center'>
//                         {!showPassword ? 
//                           <LockOutlinedIcon  onClick={togglePasswordVisibility} style={{ fontSize: '1.5vw', marginTop: '1.2vh', marginLeft: '0.5vw', zIndex: 0 }} />
//                         :
//                           <LockOpenIcon  onClick={togglePasswordVisibility} style={{ fontSize: '1.5vw', marginTop: '1.2vh', marginLeft: '0.5vw', zIndex: 0 }} />
//                         }
//                         <Divider sx={{ height: '4vh', marginLeft: '0.5vw', marginTop: '0.8vh' }} orientation="vertical" />
//                         <InputBase
//                           style={{ marginLeft: '0.5vw', marginTop: '0.5vh', fontSize: '1.25vw', width: '15.5vw' }}
//                           placeholder={translate('password')}
//                           value={input_password}
//                           onChange={(e) => setInput_Password(e.target.value)}
//                           type={showPassword ? 'text' : 'password'}
//                         />
//                       </Grid>
//                     </Grid>
//                 </Grid>
//                 <Button
//                   type="submit"
//                   disabled={!fileContent}
//                   size="medium"
//                   variant="contained"
//                   style={{ fontSize: '1vw', width: "15vw", height: '4.5vh', borderRadius: '2.5vh', marginTop: "5vh", backgroundColor: "#e84e0e", color: "white" }}
//                 >
//                   {translate('login_button')}
//                 </Button>
//                 <IconButton
//                   onClick={HandleRecuerdame}
//                   size="medium"
//                   variant="contained"
//                   style={{ fontSize: '1vw', width: "15vw", height: '4.5vh', borderRadius: '2.5vh', marginTop: "1vh", color: "white" }}
//                 >
//                   {!rememberMe ? <CheckBoxOutlineBlankIcon style={{fontSize:'1vw',color:"#e84e0e", marginRight:'0.5vw'}}/> : <CheckBoxIcon style={{fontSize:'1vw',color:"#e84e0e", marginRight:'0.5vw'}}/> }  {translate('recuerdame')}
//                 </IconButton>
//                 {cargando && (
//                   <Grid container justifyContent='center' style={{ marginTop: '1vh' }}>
//                     <l-dot-spinner
//                       size="40"
//                       speed="0.9"
//                       color="white"
//                     ></l-dot-spinner>
//                   </Grid>
//                 )}
//                 {fallaConexion && (
//                   <Alert severity="error" sx={{ mt: 2 }}>
//                     {error}
//                   </Alert>
//                 )}
//               </Grid>
//             </form>
//             <Grid container justifyContent='center' style={{ marginTop: '25vh' }}>
//               <h1 style={{ fontSize: '0.75vw', color: 'rgb(255,255,255,0.2)' }}>
//                 {SWVersion}
//               </h1>
//             </Grid>
//           </Grid>
//         </Grid>
//         <Grid container justifyContent='center' item xs={8} style={{ width: '50vw', marginLeft: '2vw', alignItems: 'center' }}>
//           <img src={Logo} className="rotating-image" style={{ height: '30vh', cursor: 'default !important', userSelect: 'none' }} />
//         </Grid>
//         <Grid item xs={12} style={{ marginTop: '2.5vh' }}>
//           <Base />
//         </Grid>
//       </Grid>
//     </ThemeProvider>
//   );
// };

// export default Login;
